var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPolygon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 463.672 463.672",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#8247e5;}.cls-2{fill:#fff;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ebene_2",
    "data-name": "Ebene 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 231.836,
    cy: 231.836,
    r: 231.836,
    transform: "translate(-96.03 231.836) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M293.576,190.781a15.968,15.968,0,0,0-15.044,0l-35.1,20.684-23.819,13.163-34.474,20.684a15.971,15.971,0,0,1-15.043,0l-26.952-16.3a15.276,15.276,0,0,1-7.522-13.162v-31.34a15.461,15.461,0,0,1,7.522-13.163L170.1,155.68a15.971,15.971,0,0,1,15.043,0l26.953,16.3a15.278,15.278,0,0,1,7.521,13.162v20.685l23.819-13.79V170.723a15.46,15.46,0,0,0-7.522-13.163L185.766,128.1a15.971,15.971,0,0,0-15.043,0l-51.4,30.086a13.787,13.787,0,0,0-7.522,12.536v58.919a15.459,15.459,0,0,0,7.522,13.163l50.77,29.459a15.966,15.966,0,0,0,15.043,0l34.474-20.057,23.819-13.79,34.474-20.057a15.971,15.971,0,0,1,15.043,0L319.9,234.03a15.276,15.276,0,0,1,7.522,13.162v31.34A15.459,15.459,0,0,1,319.9,291.7l-26.325,15.67a15.973,15.973,0,0,1-15.044,0L251.58,291.7a15.278,15.278,0,0,1-7.521-13.163V258.475L220.24,272.264v20.685a15.46,15.46,0,0,0,7.522,13.163l50.77,29.459a15.973,15.973,0,0,0,15.044,0l50.77-29.46a15.276,15.276,0,0,0,7.522-13.162V233.4a15.46,15.46,0,0,0-7.522-13.163Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolygon);
export default __webpack_public_path__ + "static/media/polygon.28abd14bceb8202512e7624824a7aa4c.svg";
export { ForwardRef as ReactComponent };